var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptys(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.3333 36.6667V23.3333C53.3333 19.7971 51.9285 16.4057 49.428 13.9052C46.9275 11.4048 43.5361 10 39.9999 10C36.4637 10 33.0723 11.4048 30.5718 13.9052C28.0713 16.4057 26.6666 19.7971 26.6666 23.3333V36.6667M16.6666 30H63.3333L66.6666 70H13.3333L16.6666 30Z",
    stroke: "#D1D5DB",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptys);
export default __webpack_public_path__ + "static/media/Emptys.40ad76974969a76bde72f8d6db7509bc.svg";
export { ForwardRef as ReactComponent };